import { useRequestedProductType } from "../index.js";
import { getIncrement } from "./utilities";

export const useProductTypeIncrement = () => {
  const requestedProductType = useRequestedProductType();

  return getIncrement(requestedProductType);
};